import hasSegmentation from "~/helpers/segmentation/hasSegmentation";
import { useUserStore } from "~/stores/platform/user/user.ts";

export default (component, state) => {
	const userStore = useUserStore();
	const segments = userStore.customer?.segments || [];

	const currentTimeString = useState(() => new Date().toISOString());

	if (hasSegmentation(component)) {
		const deviceSegmentation = component.segmentation.device || component.segmentation.devices;

		if (!state.execSegmentation) return false;

		let show = true;

		if (deviceSegmentation) {
			let userAgent = userStore.userAgent?.toLowerCase();

			if (deviceSegmentation.must && deviceSegmentation.must.length > 0) {
				if (!deviceSegmentation.must.some((device) => userAgent?.indexOf(device?.toLowerCase()) > -1)) return false;
			}

			if (deviceSegmentation.mustNot && deviceSegmentation.mustNot.length > 0) {
				if (deviceSegmentation.mustNot.some((device) => userAgent?.indexOf(device?.toLowerCase()) > -1)) return false;
			}
		}

		// time scheduling
		if (component.segmentation.mustBeAfterDateTime) {
			const targetDate = new Date(component.segmentation.mustBeAfterDateTime);
			if (new Date() < targetDate) return false;
		}

		if (component.segmentation.mustNotBeAfterDateTime) {
			const targetDate = new Date(component.segmentation.mustNotBeAfterDateTime);
			if (new Date() >= targetDate) return false;
		}

		const timeFrame = component.segmentation.timeFrame;
		if (timeFrame) {
			const now = new Date(currentTimeString.value);
			const currentDay = now.toLocaleDateString("en-US", { weekday: "long", timeZone: "Europe/Oslo" });
			const currentTime = now.toLocaleTimeString("no", { timeZone: "Europe/Oslo" }).slice(0, 5); // HH:mm format

			const checkTimeWindow = (timeWindow) => {
				// check days
				if (timeWindow.days && !timeWindow.days.includes(currentDay)) {
					return false;
				}

				// check time window
				if (timeWindow.time) {
					const { start, end } = timeWindow.time;
					return currentTime >= start && currentTime <= end;
				}

				return true;
			};

			if (timeFrame.must) {
				if (!checkTimeWindow(timeFrame.must)) return false;
			}

			if (timeFrame.mustNot) {
				if (checkTimeWindow(timeFrame.mustNot)) return false;
			}
		}

		if (
			component.segmentation.must ||
			component.segmentation.mustNot ||
			component.segmentation.mustNotBeLoggedIn ||
			component.segmentation.mustBeLoggedIn
		) {
			if (!userStore.customer?.firstName && !state.gizmo?.loggedIn)
				// Customer is NOT logged in
				return component.segmentation.mustNotBeLoggedIn;
			// ...but this content is exclusively for people who are not logged in
			else if (component.segmentation.mustNotBeLoggedIn)
				// Customer IS logged in, and should not see content
				return false;

			if (component.segmentation.must?.length > 0) {
				show = component.segmentation.must.some((segment) => segments.includes(segment));
			}

			if (component.segmentation.mustNot?.length > 0) {
				show = !component.segmentation.mustNot.some((segment) => segments.includes(segment));
			}
		}

		return show;
	} else {
		return true;
	}
};
